// extracted by mini-css-extract-plugin
export var formContainer = "_l5-0";
export var message = "_l5-1";